export default function BaseAddress() {
  // set up the base address
  const customerBaseUrl = localStorage.getItem('customerBaseUrl');
  const useWindowHost =
    customerBaseUrl === 'undefined' || customerBaseUrl === null;
  let baseAddress = useWindowHost
    ? window.location.protocol + '//' + window.location.hostname
    : 'https://' + customerBaseUrl;
  // we need to cater for a port number in the location. This will probably only come into play for local development.
  if (useWindowHost && !!window.location.port !== false) {
    baseAddress += ':' + window.location.port;
  }

  return baseAddress;
}
